var $$ = $$ || {};

$$.AjaxSearch = class AjaxSearch {
	constructor (root) {
		this.root = root;

		this._cacheNodes();
		this._bindEvents();

		this.waitAjaxRequest = false;

		this._debouncedAjaxRequest = _.debounce((value) => {
			this._ajaxRequest(value);
		}, 300);
	}

	_cacheNodes () {
		this.nodes = {
			input: this.root.find('.js-menu-search'),
			result: this.root.find('.js-search-results'),
		};
	}

	_bindEvents () {
		this.nodes.input
			.on('focusin', (event) => {
				$(event.currentTarget).addClass('focus');
			})
			.on('focusout', (event) => {
				setTimeout(() => {
					$(event.currentTarget).removeClass('focus');
				}, 200);
			})
			.on('keyup', (event) => {
				var input = $(event.currentTarget);
				var value = input.val();

				if ( value.length < 3 || this.waitAjaxRequest ) {
					return;
				}

			    this._debouncedAjaxRequest(value);
			});
	}

	_ajaxRequest (value) {
		var data = {
			value: value
		};

		this.waitAjaxRequest = true;

		$.ajax({
			url: $$.Config.search,
			method: 'POST',
			data: data,
			success: (response) => {
				response = $.parseJSON(response);

				if (response.success) {
					this.nodes.result.html(response.success);
				} else {
					this.nodes.result.html(response.error);
				}
			},
			complete: () => {
				this.waitAjaxRequest = false;
			}
		});
	}
};
